import { render, staticRenderFns } from "./BoardCategoryComponent.vue?vue&type=template&id=2dfe11ed&scoped=true&"
import script from "./BoardCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./BoardCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe11ed",
  null
  
)

export default component.exports